//const GoogleMaps = require('./../../../../global/js/modules/google-maps');
const VueUtils = require('../../../modules/vue-utils');

let $bookingApp,
    $dialog,
    $over25Toggle, $under25NoticeContainer,
    $createAccountToggle, $createAccountGroup
;


function _resolveElements() {

    $dialog = VueUtils.getRef('modal-dialog');

    if (!$dialog) {
        throw 'Unable to find modal dialog';
    }

    $over25Toggle = $bookingApp.querySelector('#booking-app .row.over-25.warnings input[type="checkbox"]');

    if (!$over25Toggle) {
        throw 'Unable to find under 25 checkbox';
    }

    $under25NoticeContainer = $bookingApp.querySelector('#booking-app .row.over-25.warnings .notice');

    if (!$under25NoticeContainer) {
        throw 'Unable to find under 25 notice container';
    }

    $createAccountToggle = $bookingApp.querySelector('#booking-app .row.create-account-toggle input[type="checkbox"]');
    $createAccountGroup = $bookingApp.querySelector('#booking-app .create-account-group');
}


document.addEventListener('DOMContentLoaded', () => {
    $bookingApp = document.querySelector('#booking-app');

    if (!document.querySelector('html.make-booking.review') || !$bookingApp) {
        return;
    }

    try {
        _resolveElements();
    }
    catch (e) {
        //be silent....
        return;
    }

    $under25NoticeContainer.remove();

    $over25Toggle.addEventListener('change', event => {
        if (!$over25Toggle.checked) {
            $dialog.setContent($under25NoticeContainer.innerHTML, true);
        }
    });

    $over25Toggle.addEventListener('change', event => {
        if (!$over25Toggle.checked) {
            $dialog.setContent($under25NoticeContainer.innerHTML, true);
        }
    });

    if ($createAccountToggle && $createAccountGroup) {
        if (!$createAccountToggle.checked) {
            $createAccountGroup.style.display = 'none';
        }
        $createAccountToggle.addEventListener('change', event => {
            $createAccountGroup.style.display = $createAccountToggle.checked
                ? ''
                : 'none'
            ;

            for (const $input of $createAccountGroup.querySelectorAll('input[type=password')) {
                if ($createAccountToggle.checked) {
                    $input.setAttribute('required', true);
                }
                else {
                    $input.removeAttribute('required');
                }
            }
        });

    }
});
